import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import {
  CentralServiceResources as cs,
} from 'se-resource-types'

const exampleHtml = `
<se-po-persona-choice
  (edit)="onEdit($event)"
  (chosen)="onChosen($event)"
  [profile]="profile1"
></se-po-persona-choice>
`

const exampleTypescript = `
import { Component } from '@angular/core'
import { CentralServiceResources as cs } from 'se-resource-types'

export class PersonaChoiceComponent {
  // Profile missing the first_name field
  public profile1: cs.Households.UserProfile = {
    id: '1',
    relationship: 'self',
    access: 'owner',
    persona: {
      id: 1,
      gender: 'female',
      first_name: '',
      full_name: 'Hannah Barbera',
      last_name: 'Barbera',
      date_of_birth: '1957-07-07',
    }
  } as cs.Households.UserProfile

  public onEdit(e: Event): void {
    console.log('onEdit', e)
  }

  public onChosen(e: Event): void {
    console.log('onChosen', e)
  }
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-choice-example-with-default-fields',
  template,
  styleUrls: ['./persona-choice-docs.component.scss'],
  standalone: false,
})
export class PersonaChoiceExampleWithDefaultFieldsComponent extends SeFeDocsExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public profile1: cs.Households.UserProfile = {
    id: '1',
    relationship: 'self',
    access: 'owner',
    persona: {
      id: 1,
      gender: 'female',
      first_name: '',
      full_name: 'Hannah Barbera',
      last_name: 'Barbera',
      date_of_birth: '1957-07-07',
    }
  } as cs.Households.UserProfile

  public onEdit(e: Event): void {
    console.log('onEdit', e)
  }

  public onChosen(e: Event): void {
    console.log('onChosen', e)
  }
}
